import { render, staticRenderFns } from "./StaticInfosForm.vue?vue&type=template&id=3238b2a1&scoped=true"
import script from "./StaticInfosForm.vue?vue&type=script&lang=js"
export * from "./StaticInfosForm.vue?vue&type=script&lang=js"
import style0 from "./StaticInfosForm.vue?vue&type=style&index=0&id=3238b2a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3238b2a1",
  null
  
)

export default component.exports